import { render, staticRenderFns } from "./CoordinatesInput.vue?vue&type=template&id=28877336&scoped=true"
import script from "./CoordinatesInput.vue?vue&type=script&lang=ts"
export * from "./CoordinatesInput.vue?vue&type=script&lang=ts"
import style0 from "./CoordinatesInput.vue?vue&type=style&index=0&id=28877336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28877336",
  null
  
)

export default component.exports